export default __webpack_public_path__ + "static/media/trus6.d2e54c6c.png";